/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CurrentVersion
 */
export interface CurrentVersion {
  /**
   *
   */
  readonly threediVersion?: string;
  /**
   *
   */
  readonly threedicoreVersion?: string;
}

/**
 * Check if a given object implements the CurrentVersion interface.
 */
export function instanceOfCurrentVersion(value: object): value is CurrentVersion {
  return true;
}

export function CurrentVersionFromJSON(json: any): CurrentVersion {
  return CurrentVersionFromJSONTyped(json, false);
}

export function CurrentVersionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CurrentVersion {
  if (json == null) {
    return json;
  }
  return {
    threediVersion: json["threedi_version"] == null ? undefined : json["threedi_version"],
    threedicoreVersion:
      json["threedicore_version"] == null ? undefined : json["threedicore_version"],
  };
}

export function CurrentVersionToJSON(json: any): CurrentVersion {
  return CurrentVersionToJSONTyped(json, false);
}

export function CurrentVersionToJSONTyped(
  value?: Omit<CurrentVersion, "threediVersion" | "threedicoreVersion"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {};
}
